var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFireTruck = function SvgFireTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.25 10.356a.75.75 0 0 1-.75.75h-.75v7.5a1.5 1.5 0 0 1-1.5 1.5H18a1.5 1.5 0 0 1-1.5-1.5v-.75h-9v.75a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5v-7.5H1.5a.75.75 0 1 1 0-1.5h1.065L5.133 5.11a1.5 1.5 0 0 1 1.302-.756h11.13a1.5 1.5 0 0 1 1.302.756l2.568 4.494H22.5a.75.75 0 0 1 .75.75m-15 3a.75.75 0 0 0-.75-.75H5.25a.75.75 0 1 0 0 1.5H7.5a.75.75 0 0 0 .75-.75m11.25 0a.75.75 0 0 0-.75-.75H16.5a.75.75 0 1 0 0 1.5h2.25a.75.75 0 0 0 .75-.75m.207-3.75-2.142-3.75H6.435l-2.142 3.75z"
  })));
};
export default SvgFireTruck;